import { secondsToMilliseconds } from 'date-fns';

export const DEFAULT_POLL_RATE_IN_MILLISECONDS = secondsToMilliseconds(30);
